(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  /**
   * Submitting the cart when a quantity changes. Progressive enhancement: the
   * <noscript> update button covers the case where this never runs.
   */
  document.querySelectorAll('[data-cart-qty]').forEach((select) => {
    select.addEventListener('change', () => {
      select.closest('[data-cart-form]')?.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /**
   * Collection filtering. Progressive enhancement only: the sidebar is a GET
   * form inside a <details> drawer, and both work with this script absent.
   * With it, every change re-renders the grid and the filters in place through
   * the Section Rendering API and keeps the URL in step with history; the
   * mobile drawer gains scroll lock, a click-away backdrop and Escape.
   *
   * Wrapped: section javascript blocks are concatenated into one bundle, so
   * nothing here may sit in the shared top-level scope.
   */
  (() => {
    const DESKTOP = window.matchMedia('(min-width: 900px)');

    // Elements re-rendered by the Section Rendering API. Text-only targets are
    // updated in place so the count's live region keeps announcing.
    const SWAP = ['[data-facets-content]', '[data-facets-count]', '[data-collection-results]'];
    const TEXT = ['[data-collection-count]', '[data-facets-apply]'];

    // Links Shopify builds from the fetch URL carry the section_id parameter
    // along; a shopper following one would land on a bare section.
    const stripSectionParam = (root) => {
      root.querySelectorAll('a[href*="section_id="], [formaction*="section_id="]').forEach((el) => {
        const attr = el.hasAttribute('href') ? 'href' : 'formaction';
        const url = new URL(el.getAttribute(attr), window.location.origin);
        url.searchParams.delete('section_id');
        el.setAttribute(attr, url.pathname + url.search + url.hash);
      });
    };

    const initCollection = (root) => {
      if (root.hasAttribute('data-js')) return;
      root.setAttribute('data-js', '');

      const sectionId = root.dataset.sectionId;
      const q = (selector) => root.querySelector(selector);
      const details = q('[data-facets]');
      const form = q('[data-facets-form]');
      const sort = q('[data-collection-sort]');

      /* ---- Sidebar on desktop, drawer below it ---------------------------- */
      const lockScroll = (on) => {
        document.documentElement.style.overflow = on ? 'hidden' : '';
      };

      const closeDrawer = () => {
        if (!details || DESKTOP.matches || !details.open) return;
        details.open = false;
        details.querySelector('summary')?.focus();
      };

      if (details) {
        // Open as a sidebar on desktop; closed as a drawer below. Re-evaluated
        // when the viewport crosses the breakpoint so a drawer left open never
        // survives a rotation into the sidebar layout, or the reverse.
        const syncViewport = () => {
          details.open = DESKTOP.matches;
          lockScroll(false);
        };
        syncViewport();
        DESKTOP.addEventListener('change', syncViewport);

        details.addEventListener('toggle', () => {
          if (!DESKTOP.matches) lockScroll(details.open);
        });

        root.addEventListener('click', (event) => {
          if (event.target.closest('[data-facets-backdrop]')) closeDrawer();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeDrawer();
        });
      }

      /* ---- Fetch and swap ------------------------------------------------- */
      let controller = null;

      const render = async (url, { push = true, focusId = null } = {}) => {
        controller?.abort();
        controller = new AbortController();
        q('[data-collection-results]')?.setAttribute('aria-busy', 'true');

        try {
          const fetchUrl = new URL(url, window.location.origin);
          fetchUrl.searchParams.set('section_id', sectionId);
          const res = await fetch(fetchUrl, { signal: controller.signal });
          if (!res.ok) throw new Error(String(res.status));

          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          SWAP.forEach((selector) => {
            const next = doc.querySelector(selector);
            const current = q(selector);
            if (next && current) current.replaceWith(next);
          });
          TEXT.forEach((selector) => {
            const next = doc.querySelector(selector);
            const current = q(selector);
            if (next && current) current.textContent = next.textContent;
          });
          stripSectionParam(root);

          if (push) window.history.pushState({ collection: true }, '', url);
          if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
        } catch (error) {
          if (error.name === 'AbortError') return;
          // Anything unexpected falls back to the ordinary navigation, so the
          // shopper never loses the ability to filter.
          window.location.href = url;
        }
      };

      // The form's own fields plus the sort select, which is associated through
      // its form attribute. Blank fields (an untouched price box) stay out of
      // the URL.
      const buildUrl = (basePath) => {
        const params = new URLSearchParams();
        if (form) {
          new FormData(form).forEach((value, key) => {
            if (value !== '') params.append(key, value);
          });
        } else {
          new URLSearchParams(window.location.search).forEach((value, key) => {
            if (key !== 'page' && key !== 'sort_by') params.append(key, value);
          });
          if (sort) params.set('sort_by', sort.value);
        }
        const query = params.toString();
        return query ? `${basePath}?${query}` : basePath;
      };

      const basePath = () => (form ? form.getAttribute('action') : window.location.pathname);

      if (form) {
        // Ticking a box applies it straight away. In the drawer the results
        // update behind the panel and the "Show N results" button keeps count.
        form.addEventListener('change', (event) => {
          render(buildUrl(basePath()), { focusId: event.target.id });
        });

        // Submits come from the Apply button, a keyword chip (whose formaction
        // is the tag path), or Enter in a price field.
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const formaction = event.submitter?.getAttribute('formaction');
          // A GET submission replaces the action's own query string with the
          // form's fields; take only the path so script and no-script agree.
          const action = formaction
            ? new URL(formaction, window.location.origin).pathname
            : basePath();
          render(buildUrl(action));
          if (event.submitter?.hasAttribute('data-facets-apply')) closeDrawer();
        });
      }

      sort?.addEventListener('change', () => render(buildUrl(basePath())));
      q('[data-sort-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        render(buildUrl(basePath()));
      });

      // Applied-filter chips and "clear all" are links Shopify builds for us.
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-facet-link]');
        if (link) {
          event.preventDefault();
          render(link.getAttribute('href'));
          return;
        }

        // Paging swaps the grid in place, then puts the shopper at the top of
        // the results rather than wherever the previous page's last row ended.
        const page = event.target.closest('.collection__pagination a[href]');
        if (!page) return;
        event.preventDefault();
        render(page.getAttribute('href')).then(() => {
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
        });
      });

      window.addEventListener('popstate', () => {
        render(window.location.pathname + window.location.search, { push: false });
        if (sort) {
          sort.value = new URLSearchParams(window.location.search).get('sort_by') || sort.dataset.default;
        }
      });
      window.history.replaceState({ collection: true }, '', window.location.href);
    };

    document.querySelectorAll('[data-collection]').forEach(initCollection);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-collection]').forEach(initCollection);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Progressive enhancement only. Every <details> here already opens, closes,
   * and announces itself without this script. It adds: scroll-lock and
   * Escape-to-close for the mobile drawer, hover-to-open and click-outside-to-
   * close for desktop dropdowns, and focusing the search field when the search
   * disclosure opens. If it never runs, navigation still works (Principle V).
   */
  document.querySelectorAll('details[scroll-lock]').forEach((el) => {
    el.addEventListener('toggle', () => {
      document.documentElement.style.overflow = el.open ? 'hidden' : '';
    });
  });

  const dropdowns = Array.from(document.querySelectorAll('[data-header-dropdown]'));
  const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  dropdowns.forEach((dd) => {
    let closeTimer;
    if (hoverable) {
      dd.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        dd.open = true;
      });
      dd.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => { dd.open = false; }, 120);
      });
    }
    // Only one dropdown open at a time.
    dd.addEventListener('toggle', () => {
      if (!dd.open) return;
      dropdowns.forEach((other) => { if (other !== dd) other.open = false; });
    });
  });

  const search = document.querySelector('[data-header-search]');
  search?.addEventListener('toggle', () => {
    if (search.open) search.querySelector('input[type="search"]')?.focus();
  });

  document.addEventListener('click', (event) => {
    [...dropdowns, search].filter(Boolean).forEach((el) => {
      if (el.open && !el.contains(event.target)) el.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[scroll-lock][open], [data-header-dropdown][open], [data-header-search][open]').forEach((el) => {
      el.open = false;
      el.querySelector('summary')?.focus();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * Progressive enhancement for the product page.
   *
   * Keeps the hidden variant id, price, add-to-cart state, gallery and URL in
   * sync with the radio inputs. Everything here is an enhancement: the radios
   * are keyboard-operable on their own, and a <noscript> select submits a real
   * variant if this never runs.
   */
  (() => {
    const root = document.querySelector('.product');
    if (!root) return;

    const dataEl = document.querySelector('[data-variant-data]');
    if (!dataEl) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const idInput = root.querySelector('[data-variant-id]');
    const priceBlock = root.querySelector('[data-price-block]');
    const addButton = root.querySelector('[data-add-button]');
    const addLabel = root.querySelector('[data-add-label]');
    const mainImage = root.querySelector('[data-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const strings = {
      add: addLabel ? addLabel.textContent.trim() : '',
      soldOut: root.dataset.soldOutLabel || ''
    };

    const selectedOptions = () =>
      [...root.querySelectorAll('.variant-select__input')]
        .sort((a, b) => a.dataset.position - b.dataset.position)
        .map((select) => select.value);

    const ghost = root.querySelector('[data-gallery-ghost]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let swapToken = 0;

    const markActive = (thumb) => {
      thumbs.forEach((t) => {
        const active = t === thumb;
        t.classList.toggle('gallery__thumb--active', active);
        if (active) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    };

    const showMedia = async (mediaId) => {
      if (!mediaId || !mainImage) return;
      const thumb = thumbs.find((t) => Number(t.dataset.mediaId) === Number(mediaId));
      if (!thumb) return;

      // element.src reports a resolved absolute URL, so the data attribute has
      // to be resolved too or this comparison never matches.
      const nextSrc = new URL(thumb.dataset.full, window.location.href).href;
      if (mainImage.src === nextSrc) return;

      // The selection should respond instantly, before any image work.
      markActive(thumb);

      const applyImage = () => {
        mainImage.src = nextSrc;
        mainImage.srcset = thumb.dataset.fullSrcset || '';
        mainImage.alt = thumb.dataset.alt || '';
      };

      if (reduceMotion.matches || !ghost) {
        applyImage();
        return;
      }

      // Guards against a stale swap resolving after a newer one, which would
      // otherwise leave the wrong image showing.
      const token = ++swapToken;

      // Hold the outgoing frame on top.
      ghost.src = mainImage.currentSrc || mainImage.src;
      ghost.srcset = mainImage.srcset || '';
      ghost.classList.remove('gallery__ghost--fading');
      ghost.classList.add('gallery__ghost--visible');

      // Decode before swapping so the incoming image paints in one go instead
      // of appearing part-way through the fade.
      //
      // Capped with a timeout because decode() can simply never settle — it
      // does not resolve at all while the page is hidden, and a hung promise
      // would leave the ghost covering the gallery forever. Past the cap we
      // swap regardless; the image then paints whenever it is ready.
      const incoming = new Image();
      incoming.srcset = thumb.dataset.fullSrcset || '';
      incoming.src = nextSrc;
      const ready = incoming.decode
        ? incoming.decode()
        : new Promise((res) => { incoming.onload = incoming.onerror = res; });
      await Promise.race([
        ready.catch(() => {}),
        new Promise((res) => setTimeout(res, 400))
      ]);

      if (token !== swapToken) return;
      applyImage();

      // Two frames: one for the swap to paint, one for the transition to take.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (token === swapToken) ghost.classList.add('gallery__ghost--fading');
        });
      });

      // Clear the ghost on transitionend, with a timer as backup: the event
      // never fires if the transition is skipped (reduced motion, hidden tab,
      // interrupted swap), and a ghost left visible hides the product image.
      let cleared = false;
      const clearGhost = () => {
        if (cleared || token !== swapToken) return;
        cleared = true;
        ghost.removeEventListener('transitionend', clearGhost);
        ghost.classList.remove('gallery__ghost--visible', 'gallery__ghost--fading');
        ghost.removeAttribute('src');
      };
      ghost.addEventListener('transitionend', clearGhost);
      setTimeout(clearGhost, 600);
    };

    const update = () => {
      const chosen = selectedOptions();
      const match = variants.find(
        (v) => v.options.length === chosen.length && v.options.every((o, i) => o === chosen[i])
      );
      if (!match) return;

      if (idInput) idInput.value = match.id;

      if (priceBlock) {
        // The price snippet renders every part and hides the unused ones, so
        // this only swaps text and toggles `hidden`; nothing is re-templated.
        const onSale = !!match.compare_at_price;
        const setText = (sel, text) => {
          const el = priceBlock.querySelector(sel);
          if (el) el.textContent = text || '';
        };
        const setShown = (sel, on) => {
          priceBlock.querySelectorAll(sel).forEach((el) => { el.hidden = !on; });
        };
        setText('[data-price-current]', match.price);
        setText('[data-price-compare]', match.compare_at_price);
        setText('[data-price-savings]', match.savings);
        setShown('[data-price-now], [data-price-sale-label], [data-price-was]', onSale);
        setShown('[data-price-savings-row]', onSale && !!match.savings);
        priceBlock.querySelector('[data-price]')?.classList.toggle('price--on-sale', onSale);
      }

      if (addButton) {
        addButton.disabled = !match.available;
        if (addLabel && strings.soldOut) {
          addLabel.textContent = match.available ? strings.add : strings.soldOut;
        }
      }

      showMedia(match.media_id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };

    root.addEventListener('change', (event) => {
      if (!event.target.classList.contains('variant-select__input')) return;
      update();
    });

    // Gallery thumbnails
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
    });

    /**
     * Thumbnail rail arrows. The rail is vertical beside the image on desktop
     * and horizontal beneath it on mobile, so the scroll axis is detected from
     * the element rather than assumed.
     */
    const railList = root.querySelector('[data-thumb-list]');
    const railNavs = [...root.querySelectorAll('[data-thumb-scroll]')];

    if (railList && railNavs.length) {
      const isVertical = () => railList.scrollHeight > railList.clientHeight + 1;

      const syncNavs = () => {
        const vertical = isVertical();
        const size = vertical ? railList.clientHeight : railList.clientWidth;
        const total = vertical ? railList.scrollHeight : railList.scrollWidth;
        const pos = vertical ? railList.scrollTop : railList.scrollLeft;
        const scrollable = total > size + 1;
        railNavs.forEach((nav) => {
          const dir = Number(nav.dataset.thumbScroll);
          const atEnd = dir < 0 ? pos <= 1 : pos + size >= total - 1;
          nav.hidden = !scrollable || atEnd;
        });
      };

      railNavs.forEach((nav) => {
        nav.addEventListener('click', () => {
          const dir = Number(nav.dataset.thumbScroll);
          const vertical = isVertical();
          const step = (vertical ? railList.clientHeight : railList.clientWidth) * 0.8;
          railList.scrollBy(vertical ? { top: dir * step, behavior: 'smooth' } : { left: dir * step, behavior: 'smooth' });
        });
      });

      railList.addEventListener('scroll', syncNavs, { passive: true });
      window.addEventListener('resize', syncNavs);
      syncNavs();
    }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  /* Arrow buttons scroll the image track by one item. Enhancement only. */
  document.querySelectorAll('[data-promo]').forEach((root) => {
    const track = root.querySelector('[data-promo-track]');
    if (!track) return;
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 120) + 16;
    root.querySelector('[data-promo-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    root.querySelector('[data-promo-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
